import { useSearchParams } from "react-router-dom";
import { Floor } from "../../../../assets/domain";
import { useFloorsQuery } from "../../../../assets/hooks";
import { useOrganizationMembership } from "../../../../authentication/hooks";
import { useLocations } from "./useLocations";

export interface UseFloorsResult {
  floors: Floor[];
  floor: Floor | null;
  floorId: string | null;
}

function getFloorFromSearchParams(
  searchParams: URLSearchParams,
  floors: Floor[]
): [Floor | null, string | null] {
  const floorId = searchParams.get("floor");
  const floor = floors.find((it) => it.id === floorId);
  if (floor) {
    return [floor, floor.id];
  }
  // Preselect the only floor
  const preselectedFloor = floors.length === 1 ? floors[0] : null;
  return [preselectedFloor, preselectedFloor?.id ?? floorId];
}

export function useFloors(): UseFloorsResult {
  const { organization } = useOrganizationMembership();
  const [searchParams] = useSearchParams();
  const { locationId } = useLocations();
  const floorsQuery = useFloorsQuery(
    organization.id,
    { locationId: locationId ?? undefined },
    {
      enabled: !!locationId,
    }
  );
  const floors = floorsQuery.data ?? [];
  const [floor, floorId] = getFloorFromSearchParams(searchParams, floors);
  return { floors, floor, floorId };
}
